import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createVNode as _createVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  style: {"display":"flex","align-items":"center","flex-direction":"row","flex-wrap":"wrap","gap":"3px","justify-content":"center"}
}
const _hoisted_3 = {
  key: 1,
  style: {"color":"#fff","font-size":"0.85em","margin":"8px 0 8px 0","text-align":"center"}
}
const _hoisted_4 = {
  key: 1,
  style: {"display":"flex","gap":"8px","align-items":"flex-start"}
}
const _hoisted_5 = { style: {"display":"flex","gap":"4px","align-items":"center","flex-direction":"column"} }
const _hoisted_6 = {
  key: 0,
  style: {"font-size":"24px"}
}
const _hoisted_7 = { style: {"flex":"1"} }
const _hoisted_8 = { style: {"margin":"0","font-size":"0.8em","line-height":"1.2"} }
const _hoisted_9 = {
  key: 3,
  style: {"margin-top":"8px"}
}

import { computed, } from 'vue';

// icon
import { checkmarkCircle, alertCircle, createOutline, pencil, trashOutline,
        handRightOutline, peopleOutline, personOutline, calendarClearOutline, calendarOutline,
        globeOutline, star, ellipse, close, thumbsUpOutline, } from 'ionicons/icons';

// components
import { IonItem, IonIcon, IonLabel, IonNote, IonSpinner, IonBadge, IonButton, IonFab, IonFabButton, } from '@ionic/vue';
import ABProfessionSelectModal from '@/components/pss/profession/ABProfessionSelectModal.vue';

// composables
import { utils } from '@/composables/utils';
import { useStore } from '@/store';


export default /*@__PURE__*/_defineComponent({
  __name: 'ProgramItemContent',
  props: [
  "item", "idx", "fromDeckView", "allowDelete", "hideDisciplineBadges",
  "showRecommendedEvents", "hideNames", "hideBtns", "targetScoreIconColor", "schoolPredictScoreIconColor",
],
  emits: [
  "clickedPenBtn",
  "clickedTrashBtn"
],
  setup(__props, { emit: __emit }) {

// vue
const { openModal, getBandLabel, getDisciplineGroupColor, openBrowser, openImageModal, } = utils();

const store = useStore();
const allClientProgramIds = computed(() => store.getters.allClientProgramIds);

const props = __props;

const emits = __emit;

// For 'Careers' button
const openAIProfessionDeckModal = async (programId: any) => {
  const clientId = store.getters.getClientIdByProgramId(programId);
  return await openModal(ABProfessionSelectModal, { clientId, isFromProgramDeck: true });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "program-content",
    style: _normalizeStyle([{"width":"100%","display":"flex","flex-direction":"column","gap":"4px","padding":"0"}, { 'min-height': '20px' }])
  }, [
    (__props.fromDeckView)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", null, [
            (!__props.hideBtns)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  (__props.item?.cardSlideImgLink)
                    ? (_openBlock(), _createBlock(_unref(IonButton), {
                        key: 0,
                        class: "no-text-transform",
                        size: "small",
                        color: "primary",
                        style: {"margin":"0","height":"24px","font-size":"0.75em"},
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(openImageModal)(__props.item?.cardSlideImgLink)))
                      }, {
                        default: _withCtx(() => _cache[4] || (_cache[4] = [
                          _createTextVNode(" Highlights ")
                        ])),
                        _: 1,
                        __: [4]
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_unref(IonButton), {
                    class: "no-text-transform",
                    size: "small",
                    color: "primary",
                    style: {"margin":"0","height":"24px","font-size":"0.75em"},
                    onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (__props.item?.programWebsite ? _unref(openBrowser)(__props.item?.programWebsite) : undefined), ["stop"]))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(__props.item?.institutionNameShort), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(IonButton), {
                    size: "small",
                    color: "primary",
                    style: {"margin":"0","height":"24px","font-size":"0.75em"},
                    onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (__props.item?.jupasUrl ? _unref(openBrowser)(__props.item?.jupasUrl) : undefined), ["stop"]))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(__props.item?.jupasCode), 1)
                    ]),
                    _: 1
                  }),
                  (allClientProgramIds.value.includes(__props.item?.id))
                    ? (_openBlock(), _createBlock(_unref(IonButton), {
                        key: 1,
                        class: "no-text-transform",
                        size: "small",
                        color: "primary",
                        style: {"margin":"0","height":"24px","font-size":"0.75em"},
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (openAIProfessionDeckModal(__props.item?.id)))
                      }, {
                        default: _withCtx(() => _cache[5] || (_cache[5] = [
                          _createTextVNode(" Careers ")
                        ])),
                        _: 1,
                        __: [5]
                      }))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (!__props.hideNames)
              ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(__props.item?.name), 1))
              : _createCommentVNode("", true)
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            (__props.idx != null)
              ? (_openBlock(), _createElementBlock("b", _hoisted_6, _toDisplayString(_unref(getBandLabel)(__props.idx)), 1))
              : _createCommentVNode("", true),
            _createVNode(_unref(IonIcon), {
              size: "large",
              icon: _unref(ellipse),
              color: __props.targetScoreIconColor || 'danger'
            }, null, 8, ["icon", "color"]),
            _createVNode(_unref(IonIcon), {
              size: "large",
              icon: _unref(star),
              color: __props.schoolPredictScoreIconColor || 'danger'
            }, null, 8, ["icon", "color"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", null, _toDisplayString(__props.item.jupasCode), 1),
            _createElementVNode("small", _hoisted_8, [
              _createElementVNode("span", null, _toDisplayString(__props.item.label), 1)
            ])
          ])
        ])),
    (__props.showRecommendedEvents)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          style: _normalizeStyle({ 'padding-left': __props.fromDeckView ? '0' : '48px' })
        }, [
          _createVNode(_unref(IonItem), {
            lines: "full",
            button: "",
            detail: "",
            color: "fdmtred"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonLabel), { class: "ion-text-wrap" }, {
                default: _withCtx(() => _cache[6] || (_cache[6] = [
                  _createElementVNode("p", { style: {"margin":"0","color":"#fff"} }, "HK$300k per awardee scholarship", -1)
                ])),
                _: 1,
                __: [6]
              })
            ]),
            _: 1
          })
        ], 4))
      : _createCommentVNode("", true),
    (!__props.hideDisciplineBadges)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([...new Set(__props.item.disciplines.map(d => d.groupName))], (groupName) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "badges-scroll-container",
              key: groupName
            }, [
              _createVNode(_unref(IonBadge), {
                style: _normalizeStyle({ '--background': _unref(getDisciplineGroupColor)(groupName), fontSize: '0.75em' })
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(groupName), 1)
                ]),
                _: 2
              }, 1032, ["style"]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.item.disciplines.filter(d => d.groupName === groupName), (discipline) => {
                return (_openBlock(), _createBlock(_unref(IonBadge), {
                  key: discipline.id,
                  style: _normalizeStyle({ '--background': _unref(getDisciplineGroupColor)(discipline.groupName, true), fontSize: '10.4px', padding: '0 3px', height: '13px' })
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(discipline.name), 1)
                  ]),
                  _: 2
                }, 1032, ["style"]))
              }), 128))
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})